module.exports = __webpack_public_path__ + "img/defaultCoinIco.0dc83d86.png";